import { render } from "./AmazonAdsAccountSelectionPage.vue?vue&type=template&id=9fe97d4a&scoped=true"
import script from "./AmazonAdsAccountSelectionPage.vue?vue&type=script&lang=js"
export * from "./AmazonAdsAccountSelectionPage.vue?vue&type=script&lang=js"

import "./AmazonAdsAccountSelectionPage.vue?vue&type=style&index=0&id=9fe97d4a&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9fe97d4a"]])

export default __exports__